import { useSyncExternalStore } from 'react';

/**
 * 화면 아래 잠깐 떴다 사라지는 알림 — 창을 열 수 없거나 처리 전에 상태가 바뀐 걸 알릴 때.
 * 어디서든 showToast 로 띄우고, AdminShell 의 Toaster 가 그린다.
 */
export interface ToastItem {
  id: number;
  message: string;
}

const DURATION_MS = 3500;
let items: ToastItem[] = [];
let nextId = 1;
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

export function showToast(message: string) {
  const id = nextId++;
  // 같은 문구가 겹쳐 쌓이지 않게 이전 것을 지운다
  items = [...items.filter((t) => t.message !== message), { id, message }];
  emit();
  setTimeout(() => {
    items = items.filter((t) => t.id !== id);
    emit();
  }, DURATION_MS);
}

export function useToasts(): ToastItem[] {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => items,
  );
}
